module.exports = __webpack_public_path__ + "img/arrow_right_alt.ddc1579c.svg";